import moment from "moment";

import { EVENTS_DATE_FORMAT } from "../../../../data-hub/components/models/common/events.constants";
import {
  IParsedSecurityEvent,
  ISecurityEventsTableRow,
} from "../../../../data-hub/components/models/common/events.models";
import { useGetTimestreamDataToExport } from "../../../../data-hub/components/models/common/hooks/useGetTimestreamDataToExport";
import { useEventsFilters } from "../../../../data-hub/components/models/common/hooks/useEventsFilters";

export const useGetSecurityEventsToExport = () => {
  const { fetchTimestreamDataToExport, loading } =
    useGetTimestreamDataToExport();
  const { cameraVariable } = useEventsFilters();

  const normalizeCameraId = (id?: string | null): string => {
    if (!id) return "";

    return id.startsWith("DE#") ? id.slice(3) : id;
  };

  const getCsvDataToExport = async (): Promise<ISecurityEventsTableRow[]> => {
    const rows = await fetchTimestreamDataToExport(mapData);

    const selectedCameraId = cameraVariable?.value ?? "";
    const wanted = normalizeCameraId(selectedCameraId);

    if (!wanted) return rows;

    return rows.filter(row => normalizeCameraId(row?.cameraId) === wanted);
  };

  const mapData = (
    parsedData: IParsedSecurityEvent[]
  ): ISecurityEventsTableRow[] => {
    const mappedData: ISecurityEventsTableRow[] =
      parsedData?.map((item: IParsedSecurityEvent, index: number) => ({
        rowIndex: index + 1,
        rowId: item?.id ?? "",
        location: item?.loc_id ?? "",
        timestamp: moment.utc(item?.time).local().format(EVENTS_DATE_FORMAT),
        keyFrame: item?.keyframe ?? "",
        mediaOutput: item?.mediaOutput ?? "",
        signedUrlKeyFrame: item?.signedUrlKeyFrame ?? "",
        signedUrlMediaOutput: item?.signedUrlMediaOutput ?? "",
        cameraId: item?.camera_id ?? "",
        peopleCount: item?.people_c ?? "0",
        vehicleCount: item?.vehicle_c ?? "0",
        nodeId: item?.node_id ?? "",
        inWindow: item?.in_window ?? "",
      })) ?? [];

    return mappedData;
  };

  return { loading, getCsvDataToExport };
};
